import { Accordion } from '@trussworks/react-uswds';
import SAM_MOBILE from './DistrictContent/SAD/SAD.SAM_Mobile';

const USACEDistrictAccordion = [
  {
    id: '1',
    headingLevel: 'h3',
    title: 'Mobile District (SAM)',
    content: <SAM_MOBILE />,
  },
];

const SAD = () => (
  <>
    <section id='sad'>
      <h6 className='margin-bottom-1'>Regulatory Districts with JPA's</h6>
      <Accordion bordered items={USACEDistrictAccordion} multiselectable={true} />
    </section>
  </>
);

export default SAD;
